import React, { useEffect, useState } from "react";

import { fetchDataFromApi } from "utils";
import {
  URLS,
  SUPERVISOR_URL,
  LIST_WORKER_GROUP_URL,
  ZONE_FETCH_URL,
  REGION_FETCH_URL,
  ESTATE_FETCH_URL,
  DIVISION_FETCH_URL,
  BLOCK_FETCH_URL,
} from "configs/constants";
import Form from "components/Form";
import { useParams } from "react-router-dom";
import eightAxios from "configs/axiosConfig";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { COMPANY_FETCH_URL } from "configs/constants";

const SupervisorAssignmentForm = () => {
  const initialValues = {
    employee_id: "",
    name: "",
    zone: "",
    region: "",
    estate: "",
    division: "",
    block: "",
    supervisor: "",
    worker_group: "",
  };
  const [workerGroups, setWorkerGroups] = useState([]);
  const [selectedWorkerGroup, setSelectedWorkerGroup] = useState(null);
  const [supervisor, setSupervisor] = useState("");
  const { t } = useTranslation();
  const params = useParams();

  const validationSchema = Yup.object({
    worker_group: Yup.number()
      .min(1, "No Worker Group selected")
      .required("Worker Group/s is required")
      .typeError("Invalid Worker Group/s"),
  });

  const getWorkerGroup = (e) => {
    setSelectedWorkerGroup(e?.value);
  };

  useEffect(() => {}, [supervisor]);

  useEffect(() => {
    if (selectedWorkerGroup) {
      eightAxios
        .get(`supervisor-assignment/${selectedWorkerGroup}/get-supervisor/`)
        .then((res) => {
          setSupervisor(res.data);
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      setSupervisor(null);
    }
  }, [selectedWorkerGroup]);

  useEffect(() => {
    fetchDataFromApi(
      LIST_WORKER_GROUP_URL + "?worker_id=" + params.id,
      setWorkerGroups,
      false
    );
  }, []);

  const formFields = [
    {
      type: "renderonly",
      name: "employee_id",
      key: "employee_id",
      label: "Employee ID",
    },
    {
      type: "renderonly",
      name: "name",
      label: "Worker Name",
      key: "name",
    },
    {
      type: "reactselect",
      name: "company",
      proxyUrl: COMPANY_FETCH_URL,
      paginated: true,
      label: "Company",
      gridSize: { xs: 3, lg: 3, md: 3, sm: 3 },
      disabled: true,
    },
    {
      type: "reactselect",
      name: "zone",
      proxyUrl: ZONE_FETCH_URL,
      paginated: true,
      label: "Zone",
      gridSize: { xs: 3, lg: 3, md: 3, sm: 3 },
      disabled: true,
    },
    {
      type: "reactselect",
      name: "region",
      proxyUrl: REGION_FETCH_URL,
      optionsDependsOn: "zone",
      paginated: true,
      label: "Region",
      gridSize: { xs: 3, lg: 3, md: 3, sm: 3 },
      disabled: true,
    },
    {
      type: "reactselect",
      name: "estate",
      proxyUrl: ESTATE_FETCH_URL,
      optionsDependsOn: "region",
      paginated: true,
      label: "Estate",
      gridSize: { xs: 3, lg: 3, md: 3, sm: 3 },
      disabled: true,
    },
    {
      type: "reactselect",
      name: "division",
      label: "Division",
      proxyUrl: DIVISION_FETCH_URL,
      paginated: true,
      optionsDependsOn: "estate",
      gridSize: { xs: 3, lg: 3, md: 3, sm: 3 },
      disabled: true,
    },
    {
      type: "reactselect",
      name: "block",
      label: "Block",
      proxyUrl: BLOCK_FETCH_URL,
      paginated: true,
      optionsDependsOn: "division",
      gridSize: { xs: 3, lg: 3, md: 3, sm: 3 },
      disabled: true,
    },
    {
      type: "renderonly",
      name: "supervisor",
      label: "Supervisor",
      value: supervisor?.name,
      required: false,
    },
    {
      type: "reactselect",
      name: "worker_group",
      label: "Worker Group",
      getValue: getWorkerGroup,
      required: true,
      outerOptions: workerGroups,
    },
  ];

  const formButtons = [
    {
      type: "submit",
      label: t("Assign"),
      color: "primary",
      gridSize: { xs: 12, lg: 2, md: 4, sm: 6 },
    },
    "cancel",
  ];

  return (
    <Form
      validationSchema={validationSchema}
      initialValues={initialValues}
      submitUrl={SUPERVISOR_URL}
      listRoute={URLS.SUPERVISOR_ASSIGNMENT_LIST}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Assign Supervisor/Worker Group"
    />
  );
};

export default SupervisorAssignmentForm;
